var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("report-page", {
    attrs: {
      title: _vm.name,
      "data-to-send": _vm.dataToSend,
      "buttons-disabled": _vm.buttonsDisabled,
      "history-filter": _vm.historyFilter,
      selectedWorkspaceUUID: _vm.selectedWorkspace
    },
    scopedSlots: _vm._u([
      {
        key: "reportForm",
        fn: function() {
          return [
            _c(
              "report-field",
              { attrs: { "field-name": _vm.$tc("Workspace", 1) } },
              [
                _c("treeselect", {
                  attrs: {
                    options: _vm.workspaceOptions,
                    disabled:
                      !_vm.hasPermissionToCreateExport ||
                      _vm.workspaceSelectionDisabled ||
                      !_vm.userHasManagementPermission("workspace", "list"),
                    disableFuzzyMatching: ""
                  },
                  on: {
                    select: function($event) {
                      _vm.selectedWorkspaceGeom = $event.geom
                    }
                  },
                  model: {
                    value: _vm.selectedWorkspace,
                    callback: function($$v) {
                      _vm.selectedWorkspace = $$v
                    },
                    expression: "selectedWorkspace"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "report-field",
              [
                _c(
                  "v-radio-group",
                  {
                    attrs: { row: "", id: "radio-label-spacing" },
                    model: {
                      value: _vm.radioGroup,
                      callback: function($$v) {
                        _vm.radioGroup = $$v
                      },
                      expression: "radioGroup"
                    }
                  },
                  [
                    _c("v-radio", {
                      attrs: {
                        label: "Network",
                        value: "network",
                        color: "accent"
                      }
                    }),
                    _vm._v(" "),
                    _c("v-radio", {
                      attrs: {
                        label: "Workspace",
                        value: "workspace",
                        color: "accent"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.radioGroup === "network"
              ? _c(
                  "report-field",
                  {
                    attrs: {
                      "field-name": _vm.$t(_vm.reportParameters[0].label)
                    }
                  },
                  [
                    _c("treeselect", {
                      attrs: {
                        options: _vm.networkStartingPointOptions,
                        "load-options": _vm.getNetworkStartingPointOptions,
                        disabled:
                          !_vm.hasPermissionToCreateExport ||
                          _vm.technicalSiteLocalDisabled ||
                          !_vm.userHasPermissionToList("technical_local"),
                        "disable-branch-nodes": true,
                        disableFuzzyMatching: ""
                      },
                      on: { input: _vm.resetClosureOptions },
                      model: {
                        value: _vm.reportParameters[0].value,
                        callback: function($$v) {
                          _vm.$set(_vm.reportParameters[0], "value", $$v)
                        },
                        expression: "reportParameters[0].value"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.radioGroup === "network"
              ? _c(
                  "report-field",
                  {
                    attrs: {
                      "field-name": _vm.$tc(_vm.reportParameters[1].label, 1)
                    }
                  },
                  [
                    _c("treeselect", {
                      attrs: {
                        options: _vm.closureOptions,
                        "load-options": _vm.loadClosureOptions,
                        disabled:
                          !_vm.hasPermissionToCreateExport ||
                          _vm.technicalSiteLocalDisabled ||
                          !_vm.userHasPermissionToList("closure"),
                        normalizer: _vm.normalizer,
                        "disable-branch-nodes": true,
                        disableFuzzyMatching: ""
                      },
                      model: {
                        value: _vm.reportParameters[1].value,
                        callback: function($$v) {
                          _vm.$set(_vm.reportParameters[1], "value", $$v)
                        },
                        expression: "reportParameters[1].value"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9563ed9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9563ed9a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Reports/ReportsPages/BOMBOQ.vue
// module id = null
// module chunks = 